<template>
  <div class="page form_page js_show">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">门店老板注册|登录</h2>
        <div class="weui-form__desc">门店老板信息注册|登录,根据您的手机号完成注册登录，如果已经注册则默认登录原注册账号</div>
      </div>

      <div class="weui-form__control-area">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd"><label class="weui-label">姓名</label></div>
              <div class="weui-cell__bd">
                <input  class="weui-input" placeholder="请填写你本人名称" v-model="formSet.bossName" prop="bossName">
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd"><label class="weui-label">手机号</label></div>
              <div class="weui-cell__bd">
                <input  class="weui-input" placeholder="填写门店注册时手机号" pattern="[0-9]*" maxlength="16" v-model="formSet.bossPhone" prop="bossPhone">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="weui-form__opr-area">
        <a class="weui-btn weui-btn_primary" href="javascript:" id="showTooltips" @click="handleSubmit">确定</a>
      </div>
    </div>
  </div>
</template>

<script type="es6">
export default {
  data () {
    const validatorPhone = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    return {
      formSet: {
        id: '',
        bossName: '',
        bossPhone: '',
        userFlag: 'bossman'
      },
      flag: '',
      bossRules: {
        bossName: [
          {required: true, message: '请输入您的名字!', trigger: 'blur'}
        ],
        bossPhone: [
          {required: true, trigger: 'blur', validator: validatorPhone}
        ]
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$axios({
        method: 'post',
        url: '/v1/wShopBoss/save',
        data: this.formSet
      }).then((response) => {
        if (response.data.code==200){
          let user = {id:response.data.data.id,username:response.data.data.bossName,userPhone:response.data.data.bossPhone,userFlag:'boss'}
          this.$storage.saveStorage("user",user)
          this.$router.push({path: 'bossShops'})
        }else{
          this.$message.error(response.data.msg);
        }
      }).catch((error) => {
        console.log('保存失败', '保存失败')
        this.$message.error(error.data.msg === ''?'保存失败':error.data.msg)
      })
    },
    getBossInfo(){
      this.$axios({
        method: 'get',
        url: '/v1/wShopBoss/info?id='+this.formSet.id
      }).then((response) => {
        if (response.data.code === 200) {
          console.log("获取",response.data.data)
          this.formSet = response.data.data
        }
      }).catch((error) => {
        console.log('获取失败', '保存失败')
      })
    }
  },
  mounted () {

    this.flag = this.$route.params.id
    let boss = this.$storage.fetchStorage("user")
    if(boss != null && boss != '' ) {
      this.$router.push({path: 'bossShops'})
    }
  },
  components: {

  }
}
</script>

<style>
#app{
    height: 100%;
    margin: 0;
    padding: 0;
}
.bossCard{
  position: absolute;
  top: 5%;
  left: 5%;
  width: 90%;
  height: 60%;
}
.form{
  margin-top: 50px;
}
.btn_submit{
  width: 80%;
  margin-right: 50%;
  margin-top: 30%;
}
</style>



// WEBPACK FOOTER //
// src/views/Register/bossRegister.vue